# Route: /tracking/reasons/new
# Create a new reason vocabulary with at least one reason entry.
# Permission: ReasonVocabulary:create
#
# Implementation: hand-authored widget (`xp87-vocab-form`).
# The dynamic entries-list editor and per-field validation are owned by
# the JS component, mirroring the F914 §M pattern from xp87-tracking-record-form.
# Tier 5 scenario `tests/5-e2e/tracking/215-tracking-ui-error-control.scenario.yaml`
# (Vocabulary Creation Validation section) drives the surface.

page-tracking-vocab-create:
  type: Page
  archetype: create
  meta:
    title: $t.tracking.reasons.create.meta_title
    route: /tracking/reasons/new
    layout: shell
    auth: required
  spatial:
    display: flex
    direction: column
    gap: $spacing.xl
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - vocab-create-header
    - vocab-create-form-host

# ── Header ───────────────────────────────────────────────────────────────────

vocab-create-header:
  type: PageHeader
  content: $t.tracking.reasons.create.title
  back_route: /admin/reason-vocabularies

# ── Form host (the widget owns the form + validation) ────────────────────────

vocab-create-form-host:
  type: Widget
  ref: xp87-vocab-form
